import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { project } from "../../rbac-consts";
import { default as ClientProjectsContainer } from "./client/ProjectsContainer";

const ProjectWrapper = () => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={project.USER}
        yes={() => (
          <ClientProjectsContainer />
        )}
      />
    </>
  );
};

export default ProjectWrapper;